function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.16 13.774c0 .917-.744 1.16-1.66 1.16s-1.662-.243-1.662-1.16.744-2.161 1.661-2.161 1.661 1.244 1.661 2.161zm0 7.388c0 3.44-.744 6.228-1.66 6.228s-1.662-2.788-1.662-6.228.744-6.228 1.661-6.228 1.661 2.788 1.661 6.228zm0 12.124c0 3.21-1.66 5.813-1.66 5.813s-1.662-2.603-1.662-5.813c0-3.21.744-5.813 1.661-5.813s1.661 2.603 1.661 5.813z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.688 20.664c.246 1.818-2.736 4.56-11.899 4.96-6.873.3-12.543.194-12.789-1.624 13.767-3.536 23.42-6.516 24.688-3.336zm-52.492 0c-.246 1.818 2.736 4.56 11.899 4.96 6.873.3 12.543.194 12.789-1.624-13.767-3.536-23.42-6.516-24.688-3.336z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M28.5 11.4C28.091 8.546 29.58 5.557 25 3m5 16l8-3V8l8-5M29.7 26l8.3 2c.769 8.298 4.165 11.618 7 16"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29 27l5 4-2 10c2.313 6.793 6.73 9.764 11 13M26.953 19l-8-3V8l-8-5m16.3 23l-8.3 2c-.769 8.298-4.165 11.618-7 16"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.953 27l-5 4 2 10c-2.313 6.793-6.73 9.764-11 13"
}));

var SvgMosquito = function SvgMosquito(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMosquito, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Mosquito.28b9f865.svg";
export { ForwardRef as ReactComponent };